import React from 'react';
import { useTranslation } from 'react-i18next';

import { SetupFail } from './SetupFail';

/* istanbul ignore next -- @preserve */
export function WifiSetupFail() {
  const { t } = useTranslation();

  return <SetupFail title={t('EVSE.wifi unavailable')} description={t('EVSE.wifi unavailable text')} />;
}
